import { render, staticRenderFns } from "./WorkflowOverview.vue?vue&type=template&id=5b947e24&scoped=true"
import script from "./WorkflowOverview.vue?vue&type=script&lang=js"
export * from "./WorkflowOverview.vue?vue&type=script&lang=js"
import style0 from "./WorkflowOverview.vue?vue&type=style&index=0&id=5b947e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b947e24",
  null
  
)

export default component.exports